var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('v-spacer')],1),_c('v-content',{staticClass:"fill-height"},[_c('div',{staticClass:"d-flex align-center justify-center fill-height mobile-wrap"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }